import React from 'react';
import { OnboardingClasses } from '../onboarding.enums';
import { OnboardingStep } from '../onboarding.types';

export const ROUTE_TOUR: OnboardingStep[] = [
    {
        className: OnboardingClasses.ADD_ROUTE_BUTTON,
        title: 'Route',
        placement: 'right',
        borderRadius: 24,
        content: (
            <>
                Route consists of the beginning, stops and the end locations of
                a or a transfer. Travelity refers to all of them as <b>stops</b>
                .
                <br />
                Press <b>Add Stop</b> to start building the route
            </>
        ),
    },
];
